import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SimplePanel from '@/shared/components/SimplePanel';
import { injectIntl, FormattedMessage, FormattedNumber } from 'react-intl';
import utils from '@/shared/utils/adminpulse';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';
import Checkbox from '@/shared/components/input/Checkbox';
import messages from '../jobMessages';
import api from '@/shared/api';
import config from '@/config';

const JobDetailRelationSoftwareUpdate = ({ job, intl }) => {
  // Some json parameters might still be stored without camelcase in the db, so convert it to camelcase just in case
  const parameters = utils.toCamel(job.parameters);

  if (!parameters) return null;
  return (
    <SimplePanel title={<FormattedListValue list="jobType" id={job.jobType} />}>
      <div className="info-block container-fluid radius4B">
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.SoftwareType} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                <FormattedMessage
                  {...messages[
                    parameters.softwareType === 'otherSoftware'
                      ? 'OtherSoftware'
                      : 'SendInvoiceSoftware'
                  ]}
                />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-5 col-sm-6">
                <label>
                  <b>
                    <FormattedMessage {...messages.Software} />
                  </b>
                </label>
              </div>
              <div className="col-md-7 col-sm-6">
                {parameters.softwares?.length > 0
                  ? parameters.softwares
                      .map(x => intl.formatMessage(listItemMsg(parameters.softwareType, x)))
                      .join(', ')
                  : '/'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SimplePanel>
  );
};

JobDetailRelationSoftwareUpdate.propTypes = {
  job: PropTypes.shape({}).isRequired,
};

export default injectIntl(JobDetailRelationSoftwareUpdate);
